import { render } from "./FengMenuItem.vue?vue&type=template&id=f3351d9c"
import script from "./FengMenuItem.vue?vue&type=script&lang=js"
export * from "./FengMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__